import { Button, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { PATH_SETTINGS } from 'src/Router/paths';
import { useSubscription } from 'src/hooks/useSubscription';
import { useLocales } from 'src/locales';
import {
  GlobalAlertContainer,
  GlobalAlertDivider,
} from '../GlobalAlert/GlobalAlert';
import { colorsByExpirationTime } from '../GlobalAlert/utils';

export const FreePlanExceededAlert = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { translate } = useLocales();

  const { subscription } = useSubscription();

  const colors = useMemo(
    () => colorsByExpirationTime(theme, subscription?.createdAt || ''),
    [subscription, theme],
  );

  const goToBilling = () => {
    navigate(PATH_SETTINGS.workspace.billing);
  };

  return (
    <GlobalAlertContainer colors={colors}>
      <Typography variant="subtitle2">
        {translate('free_plan_exceeded.workspace_max_members')}
      </Typography>

      <GlobalAlertDivider colors={colors} />

      <Typography variant="body2">
        {translate('free_plan_exceeded.workspace_max_members_msg')}
      </Typography>

      <GlobalAlertDivider colors={colors} />

      <Button
        size="small"
        variant="soft"
        color="inherit"
        sx={{ mx: 2, color: colors.color }}
        onClick={goToBilling}
      >
        {translate('free_plan_exceeded.go_to_billing')}
      </Button>
    </GlobalAlertContainer>
  );
};
